export enum UrlPaths {
  DATASYNC = '/datasync',
  ORDERS_WITH_PENDENCIES = '/approvals/orders',
  APPROVAL_GROUPS = '/approvals/groups',
  ROOT = '/',
  NOT_AUTHORIZED = '/not-authorized',
  NOT_FOUND = '/not-found',
  LOGIN = '/login',
  LOGIN_CALLBACK = '/login/callback',
  FORGOT_PASSWORD = '/forgot-password',
  RESET_PASSWORD = '/reset-password',
  HOME = '/dashboard-sales',
  UPLOAD = '/upload',
  DASHBOARD_SALES = '/dashboard-sales',
  DASHBOARD_SCRIPTING = '/dashboard-scripting',
  DASHBOARD_MARKETING_RESEARCH_METRICS = '/dashboard-marketing-research-metrics',
  DASHBOARD_SCHEDULES = '/dashboard-schedules',
  DASHBOARD_SCHEDULED_VISITS = '/dashboard-scheduled-visits',
  DASHBOARD_SETTINGS = '/dashboard-settings',
  DASHBOARD_LOGS = '/dashboard-log',
  REPORTS = '/reports',
  SMARTSELL_CUSTOMIZATION = '/smartsell-customization',
  FORMS = '/forms',
  FORMS_VIEW = '/form-view',
  ACCESS_PAGE_WITH_TOKEN = '/accessPageWithToken',
  EDI_LAYOUT = '/layout-edi',
  EDI_CUSTOMERS = '/customers-edi',
  EDI_PAYMENT_CONDITION = '/payment-condition-edi',
  MIX_CUSTOMERS = '/mix-customers',
  ADVANTAGE_CLUB = '/advantage-club',
  ADVANTAGE_CLUB_HISTORY = '/advantage-club-history',
  ADVANTAGE_CLUB_BALANCE = '/advantage-club-balance',
  ORDERS = '/orders',
  ORDER_STATUS = '/orders/status',
  GOALS = '/goals',
  BANNERS = '/banners',
  PRODUCTS = '/products',
  TEMPLATES = '/templates',
  MOTIVES = '/motives',
  MESSAGES = '/messages',
  AUDIENCES = '/audiences',
  COMMUNICATION_GROUPS = '/communication-groups',
  COMMUNICATION_AUTOMATION = '/communication-automation',
  USERS = '/users',
  API_KEYS = '/api-keys',
  ROLES = '/roles',
  ACCESS_BLOCKS = '/access-control/blocks',
  VISIT_SCHEDULE = '/visit-schedule',
  VISIT_MOTIVES = '/visit-motives',
  MOTIVE_VISIT = '/visit-motives',
  TAXES = '/taxes',
  IMPORTER = '/importer',
  EXPORTER = '/exporter',
  EMAIL = '/email',
  LOGS_ORDER_CHANGE = '/logs/order-change',
  LOGS_NEW_CUSTOMER = '/logs/new-customer',
  CONFIG_PARAMETERS = '/configuration/parameters',
  CONFIG_SELLERS_PARAMETERS = '/configuration/sellers-parameters',
  SMARTSELL_SYNC_SELLER_LOCK = '/smartsell/sync/sellers-lock',
  SMARTSELL_APP_VERSION = '/smartsell/app-version',
  AUTH_SETTING = '/auth-setting',
  INTEGRATION_FASTMANAGER = '/integration-fastmanager',
  PRODUCTS_SELLERS = '/products-sellers',
  BACKGROUND_PROCESSES = '/processes/background',
  TEMP_FILES = '/files/temporary',
  DATABASE_MANAGEMENT = '/system/database-management',
  HELP_CENTER = '/system/help-center',
  TABLE_EXTENSIONS = '/system/table-extensions',
  DB_MAP = '/system/db-map'
}

export enum UrlPathsSuper {
  ROOT = '/superadmin',
  LOGIN = '/login',
  HOME = '/superadmin/dashboard',
  HOME_SALES = '/superadmin/dashboard/sales',
  HOME_ACCESS = '/superadmin/dashboard/access',
  TENANTS = '/superadmin/tenants',
  CONTACTS = '/superadmin/contacts',
  CONTACTS_DISPATCH = '/superadmin/contacts/dispatch',
  USERS = '/superadmin/users',
  INTEGRATION_MODELS = '/superadmin/integration-models',
  AI_AGENTS = '/superadmin/ai-agents',
  JOBS = '/superadmin/jobs',
  SYSTEM_LOGS = '/superadmin/system/logs',
  SMARTSELL_APP_VERSIONS = '/superadmin/smartsell/app-versions',
  ACCESS_CONTROL = '/superadmin/access-control',
}
